module.exports = __webpack_public_path__ + "static/media/boy-icon-gov-full.21a026b4.png";